import { render, staticRenderFns } from "./df-card-product-feautured.vue?vue&type=template&id=4f2d5483"
import script from "./df-card-product-feautured.ts?vue&type=script&lang=js&external"
export * from "./df-card-product-feautured.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports